























































import mixins from '@/utils/mixins';
import Proxyable from '@/mixins/proxyable';
import Colorable from '@/mixins/colorable';
import { isNil } from 'lodash';
import { SubRule } from '@/models/configurator/question';

export default mixins(Proxyable, Colorable).extend({
  props: {
    moduleId: {
      type: [Number, String],
      default: null
    },
    length: {
      type: [Number, String],
      default: 1
    },
    index: {
      type: [Number, String]
    }
  },

  computed: {
    newRuleEnabled(): boolean {
      return this.internalValue.sub_rules
        .map((rule: any) => {
          return rule.choice;
        })
        .every((choice?: number) => {
          return !isNil(choice);
        });
    }
  },
  methods: {
    tryAddRuleGroup() {
      this.$emit('tryAddRuleGroup');
    },

    removeRuleGroup() {
      this.$emit('removeRuleGroup');
    },
    addSubRule() {
      this.internalValue.sub_rules.push(
        new SubRule({
          module: Number(this.moduleId)
        })
      );
    },

    removeSubRule(index: number) {
      this.internalValue.sub_rules.splice(index, 1);

      if (!this.internalValue.sub_rules.length) {
        this.removeRuleGroup();
      }
      if (this.newRuleEnabled) {
        this.$emit('subRuleRemoved', index);
      }
    },

    finishAnswering() {
      this.$emit('subRuleAnswered');
    }
  }
});
